<ng-template dynamic-host>
</ng-template>
